<template>
    <div class="registration">
        <advertising-figure :bannerSrc="bannerSrc" />
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Questionnaire</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">调查问卷</h2>
                <span class="time">发布日期: 2022-1-15</span>
            </div>

            <el-card class="q-card">
                <h4>请访问:</h4>
                <p class="address">
                    <a href="http://www.baidu.com" target="_blank" class="lk">http://www.baidu.com</a>
                </p>
                <el-divider></el-divider>
            </el-card>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";

export default {
    name: "RegistrationPage",
    components: {
        AdvertisingFigure,
        InnerPageNav,
        publicTitle,
    },
    data() {
        return {
            bannerSrc: require("@assets/img/registration-banner.png"),
            title: "调查问卷",
        };
    },

    methods: {
        
        handleFormSubmit() {
            console.log(this.registrationForm);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

::v-deep .el-col {
    padding: 0 15px;

    .submitBtn {
        display: block;
        width: 120px;
        margin: 60px auto 0;
    }
}

::v-deep .el-select {
    width: 100%;
}

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.registration-form {
    width: 1200px;
    padding: 0 15px;
    margin: 60px auto 0;
}

.divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $defaultColor;
        }
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}

.q-card {
    width: 1200px;
    height: auto;
    margin: 0 auto;

    ::v-deep .el-card__body {
        
        padding: 30px;
    }

    h4 {
        color: $defaultColor;
    }

    .lk {
            display: block;
            margin: 5px 0 30px;
            line-height: 30px;
            color: #424242;
        }
}
</style>